// extracted by mini-css-extract-plugin
module.exports = {"content":"MortgageContent_content___X1dS"};